import {
  backgroundCss,
  borderCss,
  boxShadowCss,
  buttonHoverCss,
  FontProps,
  fontCss,
  hoverTransformCss,
  hoverTransitionCss,
  lineHeightCss,
  mobileBackgroundCss,
  mobileBorderCss,
  mobileBoxShadowCss,
  mobileButtonHoverCss,
  mobileFontCss,
  mobileHoverTransformCss,
  mobileHoverTransitionCss,
  mobileLineHeightCss,
  mobilePaddingsCss,
  paddingsCss,
} from 'common/utils/styleUtilsNew'
import styled, { css } from 'styled-components'
import { ButtonUiInterface } from '../button-ui.schema'

interface LinkButtonUiProps
  extends FontProps,
    Pick<
      ButtonUiInterface,
      | 'alignSelf'
      | 'background'
      | 'border'
      | 'boxShadow'
      | 'hover'
      | 'lineHeight'
      | 'mobileAlignSelf'
      | 'mobileBackground'
      | 'mobileBorder'
      | 'mobileBoxShadow'
      | 'mobileHover'
      | 'mobileLineHeight'
      | 'mobilePadding'
      | 'mobileWidth'
      | 'padding'
      | 'width'
    > {}

export const LinkButtonUi = styled.a<LinkButtonUiProps>`
  text-align: center;
  &:disabled {
    cursor: default;
    opacity: 0.7;
  }
  width: ${p => p.width || 'auto'};
  align-self: ${p => p.alignSelf || 'center'};
  cursor: pointer;
  ${backgroundCss}
  ${paddingsCss}
  ${fontCss}
  ${borderCss}
  ${boxShadowCss}
  ${lineHeightCss}
  ${buttonHoverCss}
  ${hoverTransformCss}
  ${hoverTransitionCss}

  ${p => p.theme.phone} {
    width: ${p => p.mobileWidth || '100%'};
    align-self: ${p => p.mobileAlignSelf || 'center'};
    ${mobileBackgroundCss}
    ${mobilePaddingsCss}
    ${mobileFontCss}
    ${mobileBorderCss}
    ${mobileBoxShadowCss}
    ${mobileLineHeightCss}
    ${mobileButtonHoverCss}
    ${mobileHoverTransformCss}
    ${mobileHoverTransitionCss}
  }

  ${p =>
    p.theme.isEditorMobileMode &&
    css`
      ${mobileButtonHoverCss}
      ${mobileHoverTransformCss}
      ${mobileHoverTransitionCss}
      ${mobileBackgroundCss}
      ${mobilePaddingsCss}
      ${mobileBorderCss}
      ${mobileFontCss}
      ${mobileBoxShadowCss}
      ${mobileLineHeightCss}
      width: ${p.mobileWidth || '100%'};
      align-self: ${p.mobileAlignSelf || 'center'};
    `}
`
